import { Add } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import type { FC } from 'react';

import type { User } from '@core/types/api/User/User';
import { useEntityDrawer } from '@web/hooks/useEntityDrawer';

import { UserDrawer } from '../../Admin/Users/UserDrawer';
import { UserList } from '../../Admin/Users/UserList';

export const TenantUsersPage: FC<{ tenantID: string }> = ({ tenantID }) => {
  const userDrawer = useEntityDrawer<User>();

  return (
    <Box>
      <Box paddingY={3} textAlign='right'>
        <Button startIcon={<Add />} variant='slab-primary' onClick={() => userDrawer.present()}>
          Add User
        </Button>
      </Box>
      <UserList editUser={userDrawer.present} tenantIdOverride={tenantID} />
      <UserDrawer
        user={userDrawer.entity}
        isOpen={userDrawer.isOpen}
        onDismiss={userDrawer.dismiss}
        tenantIdOverride={tenantID}
      />
    </Box>
  );
};
